import {
    createSelector,
} from 'reselect';

import { ARRIVAL_TYPE, DEPARTURE_TYPE } from '../../../constants';
import {
    selectSearchResults,
    selectTripMetadata,
} from './trips';

const initStationShape = {
    [ARRIVAL_TYPE]: {},
    [DEPARTURE_TYPE]: {},
};

function _groupStationsByArriveDepart(trips = [], tripMetaData = {}) {
    return trips.reduce((data, trip) => {
        if (!trip) { // ??
            return data;
        }

        const existingArriveObject = data[ARRIVAL_TYPE][trip.arriveId];
        const arriveObject = {
            exactMatch: tripMetaData[trip.tripId]?.exactDestMatch,
            name: trip.arriveName,
            tripModes: [...new Set(
                (trip.tripModes || [])
                    .concat(existingArriveObject
                        ? existingArriveObject.tripModes
                        : [])
                    .concat(trip.tripModes.length > 1
                        ? ['multi']
                        : []),
            )],
        };
        const existingDepartObject = data[ARRIVAL_TYPE][trip.arriveId];
        const departObject = {
            exactMatch: tripMetaData[trip.tripId]?.exactOriginMatch,
            name: trip.departName,
            tripModes: [...new Set(
                (trip.tripModes || [])
                    .concat(existingDepartObject
                        ? existingDepartObject.tripModes
                        : [])
                    .concat(trip.tripModes.length > 1
                        ? ['multi']
                        : []),
            )],
        };

        return {
            ...data,
            [ARRIVAL_TYPE]: {
                ...data[ARRIVAL_TYPE],
                [trip.arriveId]: arriveObject,
            },
            [DEPARTURE_TYPE]: {
                ...data[DEPARTURE_TYPE],
                [trip.departId]: departObject,
            },
        };
    }, initStationShape);
}

const selectStationsTripData = createSelector(
    selectSearchResults,
    selectTripMetadata,
    _groupStationsByArriveDepart,
);

export {
    selectStationsTripData,
};
